import { render, staticRenderFns } from "./AppointmentStep02.vue?vue&type=template&id=1c524d72&scoped=true&"
import script from "./AppointmentStep02.vue?vue&type=script&lang=js&"
export * from "./AppointmentStep02.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentStep02.vue?vue&type=style&index=0&id=1c524d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c524d72",
  null
  
)

export default component.exports